import { type RefObject, useEffect } from 'react';

export const useResizeObserver = <T extends HTMLElement>(
  ref: RefObject<T>,
  callback: (entry: ResizeObserverEntry) => void
) => {
  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new ResizeObserver(([entry]) => callback(entry));

    observer.observe(element);

    return () => observer.disconnect();
  }, [ref, callback]);
};
